import { PropTypes } from 'prop-types';
import React from 'react';

import { getFormattedDate } from '../../../utils';
import Link from '../../Link';

const CardTextBasedSmallScrolling = ({ date: _date, slug, title }) => {
  const date = _date ? getFormattedDate(_date) : false;
  return (
    <Link
      className="block pr-6 border-r lg:border-r-0 lg:pr-0 lg:border-b lg:py-8 border-smoke"
      to={`/article/${slug}/`}
    >
      <h5 className="stink-h5 text-liquorice text-hover">{title}</h5>
      {date && <p className="mt-2 stink-footnote text-slate">{date}</p>}
    </Link>
  );
};

CardTextBasedSmallScrolling.propTypes = {
  date: PropTypes.string,
  slug: PropTypes.string,
  title: PropTypes.string,
};

export default CardTextBasedSmallScrolling;
